<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav>
        <ul>
          <li>
            <router-link :to="{name: 'Podrobnosti piskotkov'}">Politika piškotkov</router-link>
          </li>
          <li>
            <a href="https://www.t-2.net/splosni-pogoji-podjetja" target="_blank">
              Splošni pogoji
            </a>
          </li>
          <li style="padding-top: 0">
            <a href="https://www.t-2.net/pritozbeni-postopek-pri-t-2" target="_blank">
              Pritožbeni postopek pri T-2
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue